import { render, staticRenderFns } from "./ConfirmationPromiseDialog.vue?vue&type=template&id=ffe168ae&lang=pug"
import script from "./ConfirmationPromiseDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationPromiseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
